import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import Services from "./pages/Services";
import ContactUs from "./pages/ContactUs";
import FreeAudit from "./pages/FreeAudit";
import ServiceDetail from "./pages/ServiceDetail";
import VideoIntro from "./pages/VideoIntro";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  const [showIntro, setShowIntro] = useState(() => {
    try {
      if (sessionStorage.getItem("uh_intro_done")) return false;
      return true;
    } catch {
      return true;
    }
  });

  const handleIntroDone = () => {
    try { sessionStorage.setItem("uh_intro_done", "1"); } catch {}
    setShowIntro(false);
  };

  if (showIntro) {
    return <VideoIntro onDone={handleIntroDone} />;
  }

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main className="min-h-screen">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:serviceId" element={<ServiceDetail />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/free-audit" element={<FreeAudit />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;